import AudioStream from '../AudioStream';

import { useAudioStreamStore } from '@src/stores';

const AudioContainer = () => {
  const { audioStreams } = useAudioStreamStore();

  return (
    <div className="audio-streams-container">
      {!!audioStreams.length ? audioStreams.map((stream) => <AudioStream key={stream.id} {...stream} />) : null}
    </div>
  );
};

export default AudioContainer;
